import {Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DecimalPipe, UpperCasePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {Subscription, tap} from 'rxjs';
import {CryptoCoin, CryptoService} from '../../services/crypto.service';
import {rNames} from '../../../app/r.names';

/** Бегущая лента топ-монет в шапке: цена ₽ + изменение за 24ч. */
@Component({
    selector: 'app-crypto-ticker',
    templateUrl: './crypto-ticker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, DecimalPipe, UpperCasePipe]
})
export class CryptoTickerComponent implements OnInit, OnDestroy {
  private crypto = inject(CryptoService);

  private readonly cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);


  protected readonly r = rNames;

  coins: CryptoCoin[] = [];
  /** API упал/лимит — ленту прячем, сайт не ломается */
  failed = false;

  private sub?: Subscription;

  ngOnInit(): void {
    // getTop() делит запрос между подписчиками и сам обновляется раз в 2 мин
    // (на сервере — разовый запрос, см. CryptoService)
    this.sub = this.crypto.getTop(6).pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
      next: coins => {
        this.coins = coins;
        this.failed = false;
      },
      error: () => this.failed = true
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
